// eslint-disable-next-line import/no-cycle
import Utils from '../../../../lib/utils';

export default {
  namespaced: true,

  state: {},

  getters: {
    breadCrumbsList: (state, getters, rootState, rootGetters) => (applicationHomeText) => {
      const linkList = [];
      let breadCrumbUrl;
      let breadCrumbText;
      const currentUrl = `${Utils.getBaseUrl()}/${Utils.getLocale()}`;

      if (
        typeof applicationHomeText !== 'undefined'
        && applicationHomeText.length > 0
      ) {
        breadCrumbUrl = currentUrl;
        breadCrumbText = applicationHomeText;
      } else {
        breadCrumbUrl = rootState.translations.navigation.scBreadcrumb.titleLink;
        breadCrumbText = rootState.translations.navigation.scBreadcrumb.title;
      }

      linkList.push({
        url: breadCrumbUrl,
        text: breadCrumbText,
        action: 'reset_all',
      });

      if (rootState.noProductFlowFlag) {
        if (!rootGetters.hasUserSearched && !rootGetters.urlParams.faq) {
          linkList.push({
            url: false,
            text: rootState.translations.navigation.scBreadcrumb.noProductTopics,
          });
        } else if (!rootGetters.hasUserSearched && rootGetters.urlParams.faq) {
          // do nothing
          // direct faq view
        } else {
          linkList.push({
            url: currentUrl,
            text: rootState.translations.navigation.scBreadcrumb.noProductTopics,
            action: 'reset_topicTag',
          });

          if (rootGetters.urlParams.searchQuery && rootGetters.urlParams.topicTag) {
            linkList.push({
              url: `${currentUrl}?topicTag=${rootGetters.urlParams.topicTag}`,
              text: rootGetters.getGeneralTagNameFromId(rootGetters.urlParams.topicTag),
              action: 'reset_searchQuery',
            });
          } else if (rootGetters.urlParams.topicTag) {
            if (rootGetters.urlParams.faq) {
              linkList.push({
                url: `${currentUrl}?topicTag=${rootGetters.urlParams.topicTag}`,
                text: rootGetters.getGeneralTagNameFromId(rootGetters.urlParams.topicTag),
                action: 'reset_faq',
              });
            } else {
              linkList.push({
                url: false,
                text: rootGetters.getGeneralTagNameFromId(rootGetters.urlParams.topicTag),
              });
            }
          }
        }
      } else if (rootGetters.hasUserIdentifiedProduct) {
        if (!rootGetters.hasUserSearched && !rootGetters.urlParams.faq) {
          linkList.push({
            url: false,
            // eslint-disable-next-line dot-notation
            text: rootGetters['product'].displayName,
          });
        } else {
          const localTab = rootGetters.urlParams.tab ? `&tab=${rootGetters.urlParams.tab}` : '';
          linkList.push({
            url: `${currentUrl}?productID=${rootGetters.urlParams.productID}${localTab}`,
            // eslint-disable-next-line dot-notation
            text: rootGetters['product'].displayName,
            action: 'reset_topicTag',
          });

          if (rootGetters.urlParams.searchQuery && rootGetters.urlParams.topicTag) {
            linkList.push({
              url: `${currentUrl}?productID=${rootGetters.urlParams.productID}&topicTag=${rootGetters.urlParams.topicTag}`,
              text: rootGetters.getGeneralTagNameFromId(rootGetters.urlParams.topicTag),
              action: 'reset_searchQuery',
            });
          } else if (rootGetters.urlParams.topicTag) {
            if (rootGetters.urlParams.faq) {
              linkList.push({
                url: `${currentUrl}?productID=${rootGetters.urlParams.productID}&topicTag=${rootGetters.urlParams.topicTag}`,
                text: rootGetters.getProductTagNameFromId(rootGetters.urlParams.topicTag),
                action: 'reset_faq',
              });
            } else {
              linkList.push({
                url: false,
                text: rootGetters.getProductTagNameFromId(rootGetters.urlParams.topicTag),
              });
            }
          }
        }
      }

      if (rootGetters.urlParams.searchQuery && (rootGetters.urlParams.faq)) {
        linkList.push({
          url: rootGetters.getUrlWithoutParam('faq'),
          text: rootGetters.urlParams.searchQuery,
          truncate: true,
          action: 'reset_faq',
        });
      } else if (rootGetters.urlParams.searchQuery) {
        linkList.push({
          url: false,
          text: rootGetters.urlParams.searchQuery,
          truncate: true,
        });
      }

      if (rootGetters.urlParams.faq) {
        let faqBreadcrumb = 'Article';

        if (
          typeof rootState.translations.supportCenterResultsPage.scEmbeddedContent !== 'undefined'
          && typeof rootState.translations.supportCenterResultsPage.scEmbeddedContent.articleLabel !== 'undefined'
        ) {
          // eslint-disable-next-line max-len
          faqBreadcrumb = rootState.translations.supportCenterResultsPage.scEmbeddedContent.articleLabel;
        }

        linkList.push({
          url: false,
          text: faqBreadcrumb,
        });
      }

      return linkList;
    },

  },

  actions: {},

};
